import {Component, OnInit} from '@angular/core';
import {SpecialCompbaser} from "../../../components/compbaser";
import {ActivatedRoute, ChildrenOutletContexts, Router} from "@angular/router";
import {EnumStudioType, IPlayerProps} from "../../../interfaces";
import {animate, style, transition, trigger} from '@angular/animations';
import {isNullOrUndefOrEmpty} from "../../../common";
import {StoreSelectorsService} from "../../../services";
import {Memoizee} from "../../../decorators/memoizee-decorator";
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
    selector: 'app-rich-text-test',
    templateUrl: './rich-text-test.component.html',
    styleUrls: ['./rich-text-test.component.scss'],
    animations: [
        trigger('fadeIn', [
            transition('* => *', [
                style({opacity: 0}),
                animate('300ms ease-in-out')
            ])
        ])
    ]
})

export class RichTextTestComponent extends SpecialCompbaser implements OnInit {
    loading = true;
    testContent = '<p>Welcome to the <strong>Rich Text Editor</strong>!</p><p>Try creating lists:</p>';

    htmlContent = '<p>Hello <strong>TinyMCE</strong>!</p>';

    // editorConfig = {
    //     base_url: '/tinymce',   // required for self-hosted
    //     suffix: '.min',
    //     height: 400,
    //     menubar: false,
    //     plugins: [
    //     'lists link'
    //     ],
    //     toolbar:
    //     'undo redo | formatselect | bold italic underline | \
    //     alignleft aligncenter alignright | \
    //     bullist numlist outdent indent | code'
    // };

    editorConfig: AngularEditorConfig = {
        spellcheck: false,
        editable: true,
        sanitize: false,
        minHeight: '300px',
        maxHeight: '600px',
        toolbarHiddenButtons: [
            [
                'fontName'
            ],
            [
                'customClasses',
                'link',
                'unlink',
                'insertImage',
                'insertVideo',
                'insertHorizontalRule',
                'removeFormat',
                'toggleEditorMode'
            ]
        ]
    };

    outHtml = "";

    constructor(
        public router: Router, 
        private contexts: ChildrenOutletContexts
    ) {
        super();
    }

    ngOnInit() {
        
    }

    @Memoizee({})
    getState() {
        return this.contexts.getContext('primary')?.route?.snapshot?.data?.['state'];
    }

    setHtml(e) {
        this.outHtml = e;
        console.log(this.outHtml);
    }
}
